
import { Button } from "element-ui";
import { mapGetters } from "vuex";
import { Connect as ConnectService } from "@/services/SOLO";
import Translations from "@/mixins/translations";
import ConnectionModal from "./ConnectionModal.vue";
import { Component, Mixins, Watch, PropSync } from "vue-property-decorator";

@Component<Connections>({
  components: {
    ConnectionModal
  }
})
export default class Connections extends Mixins(Translations) {
  @PropSync("showCreateModal", {
    type: Boolean,
    required: true,
    default: false
  })
  syncedShowCreateModal!: boolean;

  aggregators: any[] = [];
  connections: any[] = [];
  isLoading: Boolean = false

  selectedConnection: any = null;

  mounted() {
    this.getAggregators();
    this.getConnections();
  }

  viewConnection(connection: any) {
    this.$router.push(`/connect/connections/${connection.id}`);
  }

  async getAggregators() {
    try {
      let { data } = await ConnectService.getlAggregators();
      this.aggregators = data.data;
    } catch (err) {
      console.error("Error:", err);
    }
  }

  async getConnections() {
    try {
      this.isLoading = true
      let { data } = await ConnectService.getConnections();
      this.connections = data.data;
    } catch (err) {
      console.error("Error:", err);
    } finally {
      this.isLoading = false
    }
  }

  addConnection(connection: any) {
    this.connections.push(connection);
  }

  updateConnection(connection: any) {
    this.selectedConnection = connection;
  }

  get menus() {
    return this.$store.getters["menu/getMenus"];
  }

  @Watch("syncedShowCreateModal")
  onSyncedShowCreateModalChange(newVal: boolean) {
    if (!newVal) {
      this.selectedConnection = null;
    }
  }
}
